import { Component } from '@angular/core';
import { ErrorsService } from '../../../core/services/utils/errors.service';

@Component({
  selector: 'tgf-exit-form',
  templateUrl: './exit-form.component.html',
  styleUrls: ['./exit-form.component.scss']
})
export class ExitFormComponent {
  constructor(public errorsService: ErrorsService) {
  }
}
